(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomer', CompanyCustomer);

    CompanyCustomer.$inject = ['$resource', 'DateUtils'];

    function CompanyCustomer($resource, DateUtils) {
        var resourceUrl = 'api/company-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertLocalDateFromServer(data.createDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.createDate = DateUtils.convertLocalDateToServer(data.createDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.createDate = DateUtils.convertLocalDateToServer(data.createDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
